import React, { useMemo, useState } from "react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Progress } from "../components/ui/progress";
import { Badge } from "../components/ui/badge";
import { getPortfolio } from "../mock";
import { platformInsights } from "../services/knowledge";

export default function Platform() {
  const pf = getPortfolio();
  const [busyId, setBusyId] = useState(null);
  const [insights, setInsights] = useState({});
  const make = async (c) => {
    setBusyId(c.id);
    try{
      const { insights } = await platformInsights({ name: c.name, irr: c.irr, moic: c.moic, revenue: c.revenue, ebitda: c.ebitda, valueDrivers: c.valueDrivers, exitReadiness: c.exitReadiness });
      setInsights(prev => ({...prev, [c.id]: insights}));
    } catch(e){ setInsights(prev => ({...prev, [c.id]: `Error: ${e.message}`})); }
    setBusyId(null);
  };
  return (
    <div className="space-y-6">
      <div className="grid lg:grid-cols-3 gap-4">
        {pf.map(c => (
          <Card key={c.id} className="bg-white border-gray-200 text-[#383838]">
            <CardContent className="p-3 space-y-2">
              <div className="flex items-center justify-between"><div className="font-medium">{c.name}</div><Badge className="bg-gray-50">{c.moic}x MOIC</Badge></div>
              <div className="text-sm text-[#616161]">IRR {c.irr}% • Rev ${c.revenue}M • EBITDA ${c.ebitda}M</div>
              <div className="mt-1"><Progress value={c.exitReadiness} /><div className="text-xs mt-1">Exit Readiness: {c.exitReadiness}%</div></div>
              <div className="text-xs text-[#616161]">Drivers: {c.valueDrivers.join(", ")}</div>
              <Button className="bg-cyan-700 hover:bg-cyan-600 h-8" onClick={()=>make(c)} disabled={busyId===c.id}>{busyId===c.id?"Calculating…":"Increase Value"}</Button>
              {insights[c.id] && <div className="text-sm whitespace-pre-wrap bg-gray-50 rounded p-2">{insights[c.id]}</div>}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}